import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents';
import AppNavbar from './Layout/AppNavbar.vue';
import AppFooter from './Layout/AppFooter.vue';
let LogoutViewModel = class LogoutViewModel extends Vue {
    constructor() {
        super();
        this.email = '';
        this.password = '';
        this.email = '';
        this.password = '';
        this.sessionDataKey = '';
        this.redirectUrl = '';
    }
    get identityServerRedirectUrl() {
        let redirectUrl = '';
        redirectUrl = this.idpBaseUrl + '/oidc/logout';
        return redirectUrl;
    }
    get idpBaseUrl() {
        return process.env.VUE_APP_IDP_BASE_URL;
    }
    signOut() {
        const signoutForm = document.getElementById('signoutForm');
        signoutForm.action = this.identityServerRedirectUrl;
        const consent = document.getElementById('consent');
        consent.value = 'approve';
        signoutForm.submit();
    }
    cancelSignOut() {
        this.$router.push({ name: 'AileronDashboard' });
    }
    mounted() {
    }
};
LogoutViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
            AppNavbar,
            AppFooter
        }
    })
], LogoutViewModel);
export default LogoutViewModel;
